import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const CategoryTag = withFacetContext(
    FacetName.category_tag,
    withFilterContext(FilterName.category_tag, SearchFiltersDropdown, {
        hideLabel: true,
    })
)
